// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__UrA8I","Question":"ActiveQuiz_Question__3TVVq"};